
import { Box, Divider, Grid, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useEffect, useReducer, } from "react";
import { useTranslation } from "react-i18next";
import { IconLabelSwitch } from "../iconSwitch/IconLabelSwitch";
import { DefaultAutocompleteService } from "./DefaultAutocompleteService";
import "./DefaultAutocompleteStyle.scss"
import { InputAdornment } from "@material-ui/core";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";

/**
 * @author AndréK
 * 09/08/2022
 */

const useStyles = makeStyles((theme) => ({
    flag: {
        maxWidth: "40px",
        maxHeight: "40px",
        width: "auto",
        height: "auto",
    },
}));


export const DefaultAutocomplete = (props) => {
    //Props que podem ou não ser Utilizadas no componente
    const { name, value, contextKey, filterContextKey, onChange,
        disabled, label, useApi, endpoint, items, filterCanceled,
        endPointData, defaultSize, customSize, placeholder, useImage, error, multiple, limitMultiple } = props


    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case 'clear':
                return { ...initialState, items: state.items }
            default:
                throw new Error()
        }
    }

    const initialState = {
        items: [],
        value: null,
        inputValue: '',
        img: '',
        contextKey: '',
        imageIcon: null
    }


    const { t } = useTranslation();
    const str_canceled = t('canceled')
    const classes = useStyles();

    const [state, dispatch] = useReducer(reducer, initialState)

    //Lista Auxiliar para filtragem de itens
    let itemsAux = items ? items : state.items

    if (contextKey) {
        itemsAux = itemsAux.filter((item) => item.contextKey == contextKey)
    }

    if (itemsAux && state.value != null) {
        const item = state.items.find((item) => item.id === props.value);
        if (!item) {
            dispatch({ type: 'clear' })
        }
    }

    if (state.items.length && value !== state.value?.id) {
        const item = state.items.find((item) => item.id === props.value);
        if (item) {
            dispatch({
                type: 'update',
                data: {
                    value: item,
                    inputValue: item.name
                }
            });
        }
    }

    /**Monitora a forma de lista que sera utilizada pelo autocomplete ,
     * Caso contenha a prop useApi && endpoint , o sistema vai buscar a lista atravez de api.
     * Caso contenha a prop items , o sistema vai usar uma lista prédefinida pelo usuario  , 
     * padrão de obj da lista de itens : { id: 0, name: 'name', status: 1 ,img : img } (caso possua imagem incluir a tag 'img' , caso contrario remover)**/
    useEffect(() => {
        if (useApi && endpoint) {
            let newItems = []
            DefaultAutocompleteService[endpoint](endPointData ? endPointData : null)
                .then(({ data }) => {
                    data.forEach(value => {
                        if (!filterCanceled) {
                            if (!value.status) {
                                value.name = `${value.name} (${str_canceled})`
                            }

                            newItems.push({
                                id: value.id,
                                name: value.name,
                                status: value.status,
                                contextKey: value?.contextKey,
                                aditionalPropertiesList: value?.aditionalPropertiesList
                            })
                        } else {
                            if (value.status) {
                                newItems.push({
                                    id: value.id,
                                    name: value.name,
                                    status: value.status,
                                    contextKey: value?.contextKey,
                                    aditionalPropertiesList: value?.aditionalPropertiesList
                                })
                            }
                        }
                    })
                })
                .catch(() => newItems = [])
                .finally(() => {
                    dispatch({
                        type: 'update',
                        data: { items: newItems }
                    })
                })

        } else if (items) {
            dispatch({
                type: 'update',
                data: { items: items }
            })
        } else {
            dispatch({ type: 'clear' })
        }
    }, [useApi, endpoint, items])


    const handleChange = (_event, value) => {
        if (value) {
            dispatch({
                type: 'update',
                data: {
                    value: value,
                    inputValue: value.name
                }
            });
            onChange({
                target: {
                    name: name,
                    value: value.id,
                    valueComplete: value,
                    contextKey: value?.contextKey,
                    status: value?.status
                }
            });
        }
    }

    const handleInputChange = (_event, value) => {
        if (value === '') {
            dispatch({ type: 'clear' })
            onChange({
                target: {
                    name: name,
                    value: 0
                }
            })
        }
        if (value !== '') {
            dispatch({ type: 'update', data: { inputValue: value } })
        }
    };

    /**Função que renderiza o TextField do Autocomplete **/
    const renderInput = (params) => {
        return (
            <Box>
                <Box>
                    {props.iconLabelSwitch
                        ? props.iconLabelSwitch
                        : <IconLabelSwitch labelName={label} />
                    }
                </Box>
                <Box>
                    <TextField
                        {...params}
                        className={"defaultInput"}
                        fullWidth
                        variant='outlined'
                        label={state.inputValue ? null : (placeholder ? placeholder : '(Auto-Complete)')}
                        error={error}
                        size={defaultSize ? process.env.REACT_APP_TEXT_FIELD_SIZE : customSize ? customSize : null}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                (useImage ?
                                    (<InputAdornment position="start"> <img className={classes.flag} src={state.img} /></InputAdornment>)
                                    : null)
                            ),
                        }}
                    />
                </Box>
            </Box>
        )
    }

    /**Função que renderiza o itens da lista do Autocomplete ,
       caso a Props useImage esteja sendo utilizada , é possivel incluir icones junto aos itens.**/
    const renderOption = (option) => {
        return (
            <Grid item xs={12}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    {useImage ? (<img className={classes.flag} src={option.img} />) : null}
                    <div className={!option.status ? 'canceled-item-div' : ''}>{option.name}</div>
                </div>
                <Divider style={{ marginTop: "15px" }} />

            </Grid>
        )
    }

    useEffect(() => {
        if (useImage) {
            const item = items.find((item) => item.id == value)
            if (item) {
                dispatch({
                    type: 'update',
                    data: {
                        img: item.img
                    }
                });
            }
        }

    }, [value])

    // const renderTags = (options) => {
    //     return (
    //         options.map(option =>
    //             <Grid item xs={12}>
    //                 <div style={{ display: "flex", alignItems: "center" }}>
    //                     {useImage ? (<img className={classes.flag} src={option.img} />) : null}
    //                     <div className={!option.status ? 'canceled-item-div' : ''}>{option.name}</div>
    //                 </div>
    //             </Grid>
    //         ))
    // }

    return (
        <Autocomplete
            {...state}
            // multiple={multiple}
            // limitTags={limitMultiple}
            options={itemsAux}
            onChange={handleChange}
            onInputChange={handleInputChange}
            getOptionLabel={option => option.name}
            disabled={disabled}
            renderInput={renderInput}
            renderOption={renderOption}
        // renderTags={renderTags}
        />

    );
};



/* Exemplo de uso com lista pré definida sem imagem : 

    <DefaultAutocomplete
        name={"status"}
        onChange={handleChange}
        value={status}
        label={t("status")}
        defaultSize
        items={[
            { id: 0, name: t("canceled"), status: 1 },
            { id: 1, name: t("active"), status: 1 },
            { id: 2, name: t("all"), status: 1 },
        ]}
        error={error && status === 2}
        placeholder={t("status")}
    />

*/

/* Exemplo de uso com lista pré definida com imagem : 

    <DefaultAutocomplete
        name={"textValue"}
        onChange={handleChange}
        value={textValue}
        label={t("location")}
        defaultSize
        useImage
        items={[
            { id: 'ptBR', name: "Portuguese", status: 1 , img: icon_brazil},
            { id: 'en', name: "English", status: 1 , img: icon_uk},
        ]}
    />

*/


/* Exmplo de uso com api :

    <DefaultAutocomplete
        name={"idEstado"}
        onChange={handleChange}
        placeholder={t("state")}
        label={t("state")}
        useApi
        endpoint='GetStateAutocomplete'
        contextKey={idPais}
        value={idEstado}
        defaultSize
    />

*/